<div id="dept-public-admin" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Department of Public Administration</h2>
    <p class="inner-lead mt-3">
      The Department of Public Administration at Shah Satnam Ji Girls' College, Sirsa focus on the study of government policies, administrative structures, and the management of public programs. The department offers comprehensive programmes at both Undergraduate and Postgraduate levels.
    </p>

    <div class="mt-4">
      <h4 class="section-subtitle">Contact Number:</h4>
      <p class="inner-lead fw-bold"><i class="fa fa-phone me-2"></i>9466092170</p>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <div class="row g-4 mt-2">
      <div class="col-md-6">
        <h5 class="fw-bold">Undergraduate (UG)</h5>
        <ul class="inner-lead">
          <li>BA Political Science</li>
          <li>BA Public Administration</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h5 class="fw-bold">Postgraduate (PG)</h5>
        <ul class="inner-lead">
          <li>MA Public Administration (2 years / 4 Semesters)</li>
          <li>Open Elective for MA English, MA Hindi, M.Sc Maths, and M.Com students.</li>
        </ul>
      </div>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty Members</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Kiran Bala</td><td>MA Public Administration, MA Political Science, B.Ed, M.Phil.</td></tr>
          <tr><td>2</td><td>Dr. Kanta</td><td>Ph.D (Public Administration)</td></tr>
          <tr><td>3</td><td>Ms. Geeta Rani</td><td>MA Public Administration, B.Ed, M.Ed, MBA</td></tr>
          <tr><td>4</td><td>Ms. Jasbir Kaur</td><td>MA Public Administration, B.Ed, M.Ed</td></tr>
          <tr><td>5</td><td>Ms. Suman Bala</td><td>B.Ed, MA Public Administration</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Departmental Activities (2023–24)</h4>
    <ul class="inner-lead">
      <li><strong>Constitution Day Seminar:</strong> Held on 21 Nov, 2023</li>
      <li><strong>International Day of Democracy (Speech Competition):</strong> Held on 15 Sep, 2023</li>
      <li><strong>Seminar on Research Methodology:</strong> Held on 09 April, 2024</li>
      <li><strong>State Level Quiz Competition:</strong> Held on 21 Mar, 2024</li>
      <li><strong>National Unity Day Celebration:</strong> Held on 31 Oct, 2023</li>
      <li><strong>Seminar on Project Report:</strong> Held on 14 May, 2024</li>
    </ul>

  </div>
</div>
